import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class ItineraryCommentsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ItineraryCommentsConfiguration';
  readonly reportSection = ReportSection.ItineraryComments;
  nodataLocalizationKeyName = 'commentary';
  override disabledLayoutWidthControl = true;
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly name = 'enableItineraryCommentary';
  readonly displayName = 'Comments';
  readonly reportViewModelSections = [ReportViewModelSection.Itinerary_Comments];
  readonly minSize = 3;
  readonly maxSize = 3;
  readonly defaultSize = 3;
  readonly applicableReportTypes = [ReportType.Itinerary];
  override get requirePostDataInput(): boolean {
    return true;
  }
  readonly availableDataSections = [];
}
